import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Ripple } from "primereact/ripple";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from 'primereact/toast';
import { Dropdown, DropdownChangeEvent, DropdownProps } from 'primereact/dropdown';
import { confirmDialog } from 'primereact/confirmdialog';
import { businessDataAPI, contactCreateAPI, employeeCompanyDataAPI, employeePersonalDataAPI, employeeRoleDataAPI, roleCreateAPI, roleDataGetAPI, searchCompanyDetailsService, searchEmailService, subContactDataAPI } from "../../../Api/ContactApi";
import { checkEmail, checkFileImage, checkMobileNumber, checkPhoneNumber, checkRole, checkText } from "../../../Utils/Validator";
import { Role } from "../../../Controllers/Types/ContactResponse";
import { imageFileExtension } from "../../../Api/FileConstant";
import { goToTop } from "../../../Components/goToTop";
import { Dialog } from "primereact/dialog";
import EmailSearchDialog from "../EmailSearchDialog";
import CompanySearchDialog from "../CompanySearchDialog";
import { CompanyInterface } from "../../../Controllers/Types/CompanyType";
import { useSelector } from "react-redux";
import { RootState } from "../../../Controllers/Store";
import { hasPermission } from "../../../Controllers/Selectors/permissionsSelector";

interface EmployeeType {
    employee_type: string;
}

const employee_types: EmployeeType[] = [
    {
        employee_type: "Company employee"
    },
    {
        employee_type: "Self employee"
    }
];

interface ContactListArray {
    first_name: string;
    employee_type: string;
    display_role_name: string;
    pimary_phone_no: string;
};


const AddProfessionalContact: React.FC = () => {
    const [companyEmployeePage, setCompanyEmployeePage] = useState<'Company' | 'Contact'>('Company');
    const [selfEmployeePage, setSelfEmployeePage] = useState<'Personal' | 'Business' | 'Role'>('Personal');
    const toast = useRef<Toast>(null);
    const navigate = useNavigate();
    const location = useLocation();

    /* ******** contact id **************** */
    const [contactId, setContactId] = useState<number | undefined>(0);
    const [contactIdSeftEmployee, setContactIdSeftEmployee] = useState<number | undefined>(0);

    const [loading, setLoading] = useState<boolean>(false);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [successMessage, setSuccessMessage] = useState<string>('');
    const [showAddData, setShowAddData] = useState<boolean>(false);
    const [showAddedContactlist, setShowAddedContactlist] = useState<boolean>(false);

    /* ****************************************** For Company employee - start ******************************************* */

    //Company form variables
    const [companyName, setCompanyName] = useState<string>('');
    const [companyRegNo, setCompanyRegNo] = useState<string>('');
    const [companyEmail, setCompanyEmail] = useState<string>('');
    const [companyMobile, setCompanyMobile] = useState<string>('');
    const [companyLandline, setCompanyLandline] = useState<string>('');
    const [companyAddress, setCompanyAddress] = useState<string>('');
    const [companyCity, setCompanyCity] = useState<string>('');
    const [companyPostCode, setCompanyPostCode] = useState<string>('');

    /* Company error massage */
    const [errorCompanyName, setErrorCompanyName] = useState<string>('');
    const [errorCompanyRegNo, setErrorCompanyRegNo] = useState<string>('');
    const [errorCompanyEmail, setErrorCompanyEmail] = useState<string>('');
    const [errorCompanyMobile, setErrorCompanyMobile] = useState<string>('');
    const [errorCompanyLandline, setErrorCompanyLandline] = useState<string>('');
    const [errorCompanyAddress, setErrorCompanyAddress] = useState<string>('');
    const [errorCompanyCity, setErrorCompanyCity] = useState<string>('');
    const [errorCompanyPostCode, setErrorCompanyPostCode] = useState<string>('');

    //Contact form variables
    const [contactProfileImage, setContactProfileImage] = useState<string | null>(null);
    const [contactProfileImageFile, setContactProfileImageFile] = useState<File | null>(null);
    const [contactFirstName, setContactFirstName] = useState<string>('');
    const [contactLastName, setContactLastName] = useState<string>('');
    const [contactEmail, setContactEmail] = useState<string>('');
    const [contactPrimaryPhone, setContactPrimaryPhone] = useState<string>('');
    const [contactSecondaryPhone, setContactSecondaryPhone] = useState<string>('');

    /* added Contact List array */
    const [addedContactList, setAddedContactList] = useState<ContactListArray[]>([]);

    /* contact error massage */
    const [errorContactProfileImageFile, setErrorContactProfileImageFile] = useState<string>('');
    const [errorContactFirstName, setErrorContactFirstName] = useState<string>('');
    const [errorContactLastName, setErrorContactLastName] = useState<string>('');
    const [errorContactEmail, setErrorContactEmail] = useState<string>('');
    const [errorContactPrimaryPhone, setErrorContactPrimaryPhone] = useState<string>('');
    const [errorContactSecondaryPhone, setErrorContactSecondaryPhone] = useState<string>('');

    /* ****************************************** For Company employee - end ******************************************* */


    /* ****************************************** For self employee - start ******************************************* */
    //Personal form variables
    const [personalProfileImage, setPersonalProfileImage] = useState<string | null>(null);
    const [personalProfileImageFile, setPersonalProfileImageFile] = useState<File | null>(null);
    const [firstName, setFirstName] = useState<string>('');
    const [lastName, setLastName] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [mobile, setMobile] = useState<string>('');
    const [landline, setLandline] = useState<string>('');
    const [address, setAddress] = useState<string>('');
    const [city, setCity] = useState<string>('');
    const [postCode, setPostCode] = useState<string>('');

    /* error Personal data */
    const [errorPersonalProfileImageFile, setErrorPersonalProfileImageFile] = useState<string>('');
    const [errorFirstName, setErrorFirstName] = useState<string>('');
    const [errorLastName, setErrorLastName] = useState<string>('');
    const [errorEmail, setErrorEmail] = useState<string>('');
    const [errorMoblile, setErrorMoblile] = useState<string>('');
    const [errorLandline, setErrorLandline] = useState<string>('');
    const [errorAddress, setErrorAddress] = useState<string>('');
    const [errorCity, setErrorCity] = useState<string>('');
    const [errorPostCode, setErrorPostCode] = useState<string>('');

    //Business form variables
    const [businessName, setBusinessName] = useState<string>('');
    const [businessEmail, setBusinessEmail] = useState<string>('');
    const [businessMobile, setBusinessMobile] = useState<string>('');
    const [businessLandline, setBusinessLandline] = useState<string>('');
    const [businessAddress, setBusinessAddress] = useState<string>('');
    const [businessCity, setBusinessCity] = useState<string>('');
    const [businessPostCode, setBusinessPostCode] = useState<string>('');

    /* error Business data */
    const [errorBusinessName, setErrorBusinessName] = useState<string>('');
    const [errorBusinessEmail, setErrorBusinessEmail] = useState<string>('');
    const [errorBusinessMobile, setErrorBusinessMobile] = useState<string>('');
    const [errorBusinessLandline, setErrorBusinessLandline] = useState<string>('');
    const [errorBusinessAddress, setErrorBusinessAddress] = useState<string>('');
    const [errorBusinessCity, setErrorBusinessCity] = useState<string>('');
    const [errorBusinessPostCode, setErrorBusinessPostCode] = useState<string>('');
    /* ****************************************** For self employee - end ******************************************* */



    ////////////////// Role form variables ///////////////
    /* role form variables */
    const [roleName, setRoleName] = useState<string>('');

    const [errorRoleName, setErrorRoleName] = useState<string>('');

    //Role form variables
    const [roleList, setRoleList] = useState<Role[]>([]);

    const [role, setRole] = useState<Role>({ id: 0, role_name: '' });
    const [displayRoleName, setDisplayRoleName] = useState<string>('');

    const [errorRoleId, setErrorRoleId] = useState<string>('');
    const [errorDisplayRoleName, setErrorDisplayRoleName] = useState<string>('');

    ///////////////////////////////////////////////////////
    /* For permission */
    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) => hasPermission(state, screen, permission));
    };

    const isPermissionEmployee = useCanEdit('Contact', 'Employee');
    const isPermissionProfessional = useCanEdit('Contact', 'Professional');
    const isPermissionClient = useCanEdit('Contact', 'Client');

    const [showSearchCompanyDetailsModal, setShowSearchCompanyDetailsModal] = useState<boolean>(false);

    const [showSearchEmailModal, setShowSearchEmailModal] = useState<boolean>(false);
    const [showSearchSelfEmpEmailModal, setShowSearchSelfEmpEmailModal] = useState<boolean>(false);


    ////////////////// For employee type //////////////////
    const [employeeType, setEmployeeType] = useState<EmployeeType>(employee_types[0]);

    const handleEmployeeTypeChange = (e: DropdownChangeEvent) => {
        confirmDialog({
            message: 'Are you sure you want to change the employee type? The fields you entered will be cleared.',
            header: 'Alert',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => setEmployeeType(e.value),
        });
    };

    useEffect(() => {
        if (location?.state && location?.state?.contactFor) {
            const contactAddFor = location?.state?.contactFor

            if (contactAddFor === 'Company employee') {
                setEmployeeType(employee_types[0]);
            } else {
                setEmployeeType(employee_types[1]);
            }
        } else {
            setEmployeeType(employee_types[0]);
        }
    }, [location?.state]);
    /////////////////////////////////////////////////////// 


    /* **************************** role data get *************************** */
    const roleDataGet = async () => {
        const data = await roleDataGetAPI(localStorage.getItem('token') || '');
        if (data.status) {
            setRoleList(data.data || []);
        }
    }
    /* **************************** role data get *************************** */

    /* **************************** contact create *************************** */
    const contactCreate = async () => {
        const data = await contactCreateAPI("Professional", "Company", localStorage.getItem('token') || '');

        if (data.status) {
            setContactId(data.contactId);
        }

        return data.contactId;
    }

    const contactCreateForSelfEmployee = async () => {
        const data = await contactCreateAPI("Professional", "Self Employee", localStorage.getItem('token') || '');

        if (data.status) {
            setContactIdSeftEmployee(data.contactId);
        }
        return data.contactId;
    }
    /* **************************** contact create *************************** */

    /* **************************** clear All error massage *************************** */
    const clearAllErrorMassage = () => {

        setErrorCompanyName('');
        setErrorCompanyRegNo('');
        setErrorCompanyEmail('');
        setErrorCompanyMobile('');
        setErrorCompanyLandline('');
        setErrorCompanyAddress('');
        setErrorCompanyCity('');
        setErrorCompanyPostCode('');

        setErrorContactProfileImageFile('');
        setErrorContactFirstName('');
        setErrorContactLastName('');
        setErrorContactEmail('');
        setErrorContactPrimaryPhone('');
        setErrorContactSecondaryPhone('');
        setErrorRoleId('');
        setErrorDisplayRoleName('');

        setErrorPersonalProfileImageFile('');
        setErrorFirstName('');
        setErrorLastName('');
        setErrorEmail('');
        setErrorMoblile('');
        setErrorLandline('');
        setErrorAddress('');
        setErrorCity('');
        setErrorPostCode('');

        setErrorBusinessName('');
        setErrorBusinessEmail('');
        setErrorBusinessMobile('');
        setErrorBusinessLandline('');
        setErrorBusinessAddress('');
        setErrorBusinessCity('');
        setErrorBusinessPostCode('');

    };
    /* **************************** clear All error massage *************************** */

    /* ************** API Error massage show ****************** */
    function showAPIErrorComapanyData(keyName: string, error: string): void {

        if (keyName === "regno") {
            setErrorCompanyRegNo(error);
        }
        if (keyName === "email") {
            setErrorCompanyEmail(error);
        }
        if (keyName === "phone") {
            setErrorCompanyMobile(error);
        }
        if (keyName === "landline") {
            setErrorCompanyLandline(error);
        }

    }

    function showAPIErrorSubContact(keyName: string, error: string): void {

        if (keyName === "email") {
            setErrorContactEmail(error);
        }
        if (keyName === "pimary_phone_no") {
            setErrorContactPrimaryPhone(error);
        }
        if (keyName === "secondary_phone_no") {
            setErrorContactSecondaryPhone(error);
        }
        if (keyName === "profile_image") {
            setErrorContactProfileImageFile(error);
        }

    }

    function showAPIErrorPersonalData(keyName: string, error: string): void {

        if (keyName === "email") {
            setErrorEmail(error);
        }
        if (keyName === "mobile") {
            setErrorMoblile(error);
        }
        if (keyName === "landline") {
            setErrorLandline(error);
        }
        if (keyName === "profile_image") {
            setErrorPersonalProfileImageFile(error);
        }
    }

    function showAPIErrorBusinessData(keyName: string, error: string): void {

        if (keyName === "business_email") {
            setErrorBusinessEmail(error);
        }
        if (keyName === "business_phone") {
            setErrorBusinessMobile(error);
        }
        if (keyName === "business_landline") {
            setErrorBusinessLandline(error);
        }

    }
    /* ************** API Error massage show ****************** */

    /* **************************** Company (company employee) Details create - start *************************** */
    // For Save Company Details
    const handleSaveCompanyDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        clearAllErrorMassage();

        if (checkCredentialsCompanyData()) {
            setLoading(true);
            if (contactId === 0) {
                /* ***** contect create **** */
                const createdContactId = await contactCreate();

                saveProfessionalCompanyData(Number(createdContactId));
            } else {
                saveProfessionalCompanyData(Number(contactId));
            }
        } else {

        }
    }

    const saveProfessionalCompanyData = async (createdContactId: number) => {
        const data = await employeeCompanyDataAPI(Number(createdContactId), "", "", companyName, companyRegNo, companyEmail, companyMobile, companyAddress, companyCity, companyPostCode, companyLandline, localStorage.getItem('token') || '');
        setLoading(false);

        if (!data.status) { // false
            if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorComapanyData(key, value[0])
                ))
            }
        } else {
            setLoading(false);
            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'The Company info was added successfully.',
                    life: 3000
                });
            }
            setCompanyEmployeePage('Contact');
            goToTop();
        }
    }

    function checkCredentialsCompanyData(): boolean {
        const isCompanyNameValid = checkText(companyName, true, setErrorCompanyName);
        const isCompanyEmailValid = checkEmail(companyEmail, true, setErrorCompanyEmail);
        const isCompanyMobileValid = checkMobileNumber(companyMobile, true, setErrorCompanyMobile);
        const isCompanyLandlineValid = checkPhoneNumber(companyLandline, false, setErrorCompanyLandline);
        const isCompanyAddressValid = checkText(companyAddress, true, setErrorCompanyAddress);
        const isCompanyCityValid = checkText(companyCity, true, setErrorCompanyCity);
        const isCompanyPostCodeValid = checkText(companyPostCode, true, setErrorCompanyPostCode);

        return isCompanyNameValid && isCompanyEmailValid && isCompanyMobileValid && isCompanyLandlineValid && isCompanyAddressValid && isCompanyCityValid && isCompanyPostCodeValid;
    }
    /* **************************** Company (company employee) Details create - end *************************** */

    /* ************************************************** Contact (company employee) - start **************************************************************** */
    /* **************************** Role name create - start *************************** */
    const handleSaveRoleName = async (e: React.FormEvent) => {
        e.preventDefault();

        setErrorRoleName('');
        if (checkCredentialsRoleCreate()) {
            const data = await roleCreateAPI(roleName, localStorage.getItem('token') || '');

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        setErrorRoleName(value[0])
                    ))
                }
            } else {
                /* clear data */
                setRoleName('');
                setShowAddData(false);
                /* call call data function */
                roleDataGet();

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Role created successfully.',
                        life: 3000
                    });
                }
            }
        }
    }

    function checkCredentialsRoleCreate(): boolean {
        const isRoleNameValid = checkText(roleName, true, setErrorRoleName);

        return isRoleNameValid;
    }
    /* **************************** Role name create - end *************************** */


    /* **************************** Contact create - start *************************** */
    /* clear conact inupt field */
    const clearContactInput = () => {
        setContactFirstName('');
        setContactLastName('');
        setContactEmail('');
        setContactPrimaryPhone('');
        setContactSecondaryPhone('');
        setRole({ id: 0, role_name: '' });
        setErrorRoleId('');
        setDisplayRoleName('');
        setContactProfileImage(null);
        setContactProfileImageFile(null);
    }

    /* add one contact */
    const handleSaveContactDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        const responce = await saveSubContactData();

        if (responce === true) {

            setLoading(false);
            setCompanyEmployeePage('Company');

            setShowAlert(true);
            setSuccessMessage('Company Employee details added successfully.');

            setTimeout(() => {
                setShowAlert(false);
                navigate('/contact');
            }, 2000);

            goToTop();
        }
    }

    /* For add more contact - sub contact */
    const handleAddContact = async (e: React.FormEvent) => {
        e.preventDefault();
        const responce = await saveSubContactData();

        if (responce === true) {

            clearContactInput();

            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'The Contact info was added successfully',
                    life: 3000
                });
            }
        }
    };

    const saveSubContactData = async () => {

        clearAllErrorMassage();
        if (checkCredentialsContactData()) {

            if (addedContactList.length == 0) {
                var employeeType = "Main Employee";
            } else {
                var employeeType = "Sub Employee";
            }

            setLoading(true);
            const data = await subContactDataAPI(Number(contactId), employeeType, contactFirstName, contactLastName, contactEmail, contactPrimaryPhone, contactSecondaryPhone, Number(role.id), displayRoleName, contactProfileImageFile!, localStorage.getItem('token') || '');
            setLoading(false);

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        showAPIErrorSubContact(key, value[0])
                    ))
                }

                return false;
            } else {
                /* ************** set added contact list ************ */
                var array: ContactListArray = {
                    first_name: contactFirstName,
                    employee_type: employeeType,
                    pimary_phone_no: contactPrimaryPhone,
                    display_role_name: displayRoleName,

                }
                const contactList = [...addedContactList];
                contactList.push(array);

                setAddedContactList(contactList);
                /* ************** set added contact list ************ */

                return true;
            }
        } else {
            return false;
        }

    }

    function checkCredentialsContactData(): boolean {
        const isContactFirstNameValid = checkText(contactFirstName, true, setErrorContactFirstName);
        const isContactLastNameValid = checkText(contactLastName, true, setErrorContactLastName);
        const isContactEmailValid = checkEmail(contactEmail, false, setErrorContactEmail);
        const isContactPrimaryPhoneValid = checkPhoneNumber(contactPrimaryPhone, true, setErrorContactPrimaryPhone);
        const isContactSecondaryPhoneValid = checkPhoneNumber(contactSecondaryPhone, false, setErrorContactSecondaryPhone);
        const isContactRoleValid = checkRole(role, true, setErrorRoleId);
        const isContactDisplayRoleNameValid = checkText(displayRoleName, true, setErrorDisplayRoleName);
        const isFileValid = checkFileImage(contactProfileImageFile!, false, setErrorContactProfileImageFile);

        return isContactFirstNameValid && isContactLastNameValid && isContactEmailValid && isContactSecondaryPhoneValid && isContactPrimaryPhoneValid && isContactRoleValid && isContactDisplayRoleNameValid && isFileValid;
    }
    /* **************************** Contact create - end *************************** */

    //For contact image upload
    const handleContactImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (event: ProgressEvent<FileReader>) => {
                if (event.target && typeof event.target.result === 'string') {
                    setContactProfileImage(event.target.result);

                    const file = e.target.files?.[0];
                    setContactProfileImageFile(file!);
                }
            };
            reader.readAsDataURL(e.target.files[0]);
        }
    };

    // For clear image
    const clearContactImage = () => {
        setContactProfileImage(null);
        setContactProfileImageFile(null);
    };
    /* ************************************************** Contact (company employee) - end **************************************************************** */

    /* ************************************************** Contact (self employee) - start **************************************************************** */
    /* **************************** Personal Details create - start *************************** */
    // For Save Personal Details
    const handleSavePersonalDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        clearAllErrorMassage();

        if (checkCredentials()) {
            setLoading(true);
            if (contactIdSeftEmployee === 0) {
                /* ***** contect create **** */
                const createdContactIdSeftEmployee = await contactCreateForSelfEmployee();

                saveEmployeePersonalData(Number(createdContactIdSeftEmployee));
            } else {
                saveEmployeePersonalData(Number(contactIdSeftEmployee));
            }
        } else {
        }
    }

  const saveEmployeePersonalData = async (createdContactIdSeftEmployee: number) => {
        const data = await employeePersonalDataAPI(Number(createdContactIdSeftEmployee), firstName, lastName, email, mobile, landline, address, city, postCode, personalProfileImageFile!, localStorage.getItem('token') || '',null,'');
        setLoading(false);

        if (!data.status) { // false
            if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorPersonalData(key, value[0])
                ))
            }
        } else {

            setLoading(false);

            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'The Personal info was added successfully.',
                    life: 3000
                });
            }
            setSelfEmployeePage('Business');

            goToTop();
        }
    }

    function checkCredentials(): boolean {
        const isEmailValid = checkEmail(email, true, setErrorEmail);
        const isFirstNameValid = checkText(firstName, true, setErrorFirstName);
        const isLastNameValid = checkText(lastName, true, setErrorLastName);
        const isMobileValid = checkMobileNumber(mobile, false, setErrorMoblile);
        const isLandlineNumberValid = checkPhoneNumber(landline, false, setErrorLandline);
        const isAddressValid = checkText(address, true, setErrorAddress);
        const isCityValid = checkText(city, true, setErrorCity);
        const isPostCodeValid = checkText(postCode, true, setErrorPostCode);
        const isFileValid = checkFileImage(personalProfileImageFile!, false, setErrorPersonalProfileImageFile);

        return isEmailValid && isFirstNameValid && isLastNameValid && isMobileValid && isLandlineNumberValid && isAddressValid && isCityValid && isPostCodeValid && isFileValid;
    }
    /* **************************** Personal Details create - end *************************** */


    /* **************************** Business Details create - start *************************** */
    // For Save Business Details
    const handleSaveBusinessDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        clearAllErrorMassage();

        if (checkCredentialsBusinessData()) {

            setLoading(true);
            const data = await businessDataAPI(Number(contactIdSeftEmployee), businessName, businessEmail, businessMobile, businessLandline, businessAddress, businessCity, businessPostCode, localStorage.getItem('token') || '');
            setLoading(false);

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        showAPIErrorBusinessData(key, value[0])
                    ))
                }
            } else {
                setLoading(false);

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'The Business info was added successfully.',
                        life: 3000
                    });
                }

                setSelfEmployeePage('Role');

                goToTop();
            }


        } else {

        }

    }

    function checkCredentialsBusinessData() {
        const isBusinessEmailValid = checkEmail(businessEmail, false, setErrorBusinessEmail);
        const isBusinessMobileValid = checkPhoneNumber(businessMobile, false, setErrorBusinessMobile);
        const isBusinessLandlineValid = checkPhoneNumber(businessLandline, false, setErrorBusinessLandline);

        return isBusinessEmailValid && isBusinessMobileValid && isBusinessLandlineValid;
    }
    /* **************************** Business Details create - end *************************** */


    /* **************************** Role Details create - start *************************** */
    // For Save Role Details
    const handleSaveRoleDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        clearAllErrorMassage();

        if (checkCredentialsRoleInfo()) {

            setLoading(true);
            const data = await employeeRoleDataAPI(Number(contactIdSeftEmployee), Number(role.id), displayRoleName, localStorage.getItem('token') || '');
            setLoading(false);

            if (data.status) {
                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Role info created successfully.',
                        life: 3000
                    });
                }

                setLoading(false);
                setSelfEmployeePage('Personal');

                setShowAlert(true);
                setSuccessMessage('Self employee details added sussessfully.');
                setTimeout(() => {
                    setShowAlert(false);
                    handleNavigateContact();
                }, 2000);
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'An error occurred while creating the role details.',
                        life: 3000
                    });
                }
                setLoading(false);
            }
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'An error occurred while creating the role details.',
                    life: 3000
                });
            }
            setLoading(false);
        }
    }

    function checkCredentialsRoleInfo(): boolean {
        const isRoleValid = checkRole(role, true, setErrorRoleId);
        const isDisplayRoleNameValid = checkText(displayRoleName, true, setErrorDisplayRoleName);

        return isRoleValid && isDisplayRoleNameValid;
    }
    /* **************************** Role Details create - end *************************** */

    //For image upload for personal data
    const handlePersonalProfileImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (event: ProgressEvent<FileReader>) => {
                if (event.target && typeof event.target.result === 'string') {
                    setPersonalProfileImage(event.target.result);

                    const file = e.target.files?.[0];
                    setPersonalProfileImageFile(file!);
                }
            };
            reader.readAsDataURL(e.target.files[0]);
        }
    };

    // For clear image
    const clearPersonalProfileImage = () => {
        setPersonalProfileImage(null);
        setPersonalProfileImageFile(null);
    };

    /* ************************************************** Contact (seft employee) - end **************************************************************** */

    /////////////////////// For role ///////////////////////
    // For showing selected role
    const selectedRoleTemplate = (option: Role, props: DropdownProps) => {
        if (option) {
            return (
                <div className="d-flex align-items-center">
                    <div>{option.role_name}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    // For showing role options in the dropdown list
    const roleOptionTemplate = (option: Role) => {
        return (
            <div className="d-flex align-items-center">
                <div>{option.role_name}</div>
            </div>
        );
    };
    ///////////////////////////////////////////////////////

    const [minHeight, setMinHeight] = useState<string>('0px');

    const calculateMinHeight = () => {
        const windowHeight = window.innerHeight;
        const distanceFromBottom = 200;
        const calculatedHeight = windowHeight - distanceFromBottom;
        setMinHeight(`${calculatedHeight}px`);
    };

    useEffect(() => {
        roleDataGet();


        calculateMinHeight();
        window.addEventListener('resize', calculateMinHeight);

        return () => {
            window.removeEventListener('resize', calculateMinHeight);
        };
    }, []);

    const goBack = () => {
        navigate(-1);
        goToTop();
    };

    const handleCloseAlert = () => {
        setShowAlert(false);
    };

    const toggleAddData = () => {
        setShowAddData(!showAddData);
    };

    const handleNavigateAddContact = (type: 'employee' | 'professional' | 'client') => {
        const currentPage = 'professional';

        if (currentPage !== type) {
            confirmDialog({
                message: `Are you sure you want to switch to ${type}? The fields you entered will be cleared.`,
                header: 'Alert',
                icon: 'bi bi-info-circle',
                defaultFocus: 'accept',
                acceptClassName: 'p-button-danger',
                accept: () => {
                    if (type === 'employee') {
                        navigate(`/contact/employee/add`);
                    } else if (type === 'client') {
                        navigate(`/contact/client/add`);
                    } else {
                        return
                    }
                },
                dismissableMask: true,
                draggable: false,
                resizable: false,
            });
        } else {
            return;
        }
        goToTop();
    }

    const handleNavigateContact = () => {
        goToTop();
        navigate(`/contact`)
    }
    /* ************************************************************************ */



    const handleUseThisExistingCompanyDetails = (companyInterface: CompanyInterface | null) => {
        if (companyInterface != null) {
            setCompanyName(companyInterface.company_name);
            setCompanyRegNo(companyInterface.company_regno);
            setCompanyEmail(companyInterface.company_email);
            setCompanyMobile(companyInterface.company_phone);
            setCompanyAddress(companyInterface.company_address);
            setCompanyCity(companyInterface.city);
            setCompanyPostCode(companyInterface.post_code);
        }



    }

    const handleUseThisCompanyDetails = (companyInterface: CompanyInterface | null) => {
        if (companyInterface != null) {
            setCompanyName(companyInterface.company_name);
            setCompanyRegNo(companyInterface.company_regno);
            setCompanyEmail(companyInterface.company_email);
        }

        setCompanyMobile('');
        setCompanyAddress('');
        setCompanyCity('');
        setCompanyPostCode('');


    }


    //SEARCH COMPANY EMPLOYEE SEARCH EMAIL
    // const handleCloseSearchEmailModal = () => {
    //     setSearchEmail('')
    //     setIsExistsEmail(null)
    //     setIsExistsEmailError('')
    //     setShowSearchEmailModal(false);

    // }

    // const addSearchEmailModalHeader = (
    //     <div className="custom_modal_header_inner">
    //         <h5 className="modal-title fs-5">
    //             Email validity
    //         </h5>
    //         <button type="button" className="close_modal_btn p-ripple"
    //             onClick={handleCloseSearchEmailModal}>
    //             <i className="bi bi-x-circle"></i>
    //             <Ripple />
    //         </button>
    //     </div>
    // );

    // const handleSearchEmail = async () => {

    //     if(checkSearchEmailCredentials()){

    //         setLoadingSearchEmail(true);
    //         const response = await searchEmailService(searchEmail);
    //         setLoadingSearchEmail(false);

    //         if (response.status) {
    //             const _isExistsEmail = response.data['have_contact']
    //             const _isExistsEmailMsg = response.data['message']


    //             setIsExistsEmail(_isExistsEmail);
    //             setIsExistsEmailError(_isExistsEmailMsg);
    //         } else {
    //             setIsExistsEmail(false);
    //             setIsExistsEmailError('');
    //         }
    //     }



    // }

    // function checkSearchEmailCredentials(): boolean {
    //         const isSearchEmailValid = checkText(searchEmail, true, setErrorSearchEmail);

    //         return isSearchEmailValid;
    // }

    // const handleUseThisEmail = () => {
    //     setEmail(searchEmail);
    //     setShowSearchEmailModal(false);
    //     setIsExistsEmailError('')
    //     setIsExistsEmail(null)
    //     setSearchEmail('')
    // }

    //SEARCH SELF EMPLOYEE SEARCH EMAIL
    // const handleCloseSearchSelfEmpEmailModal = () => {
    //     setSearchSelfEmpEmail('')
    //     setIsExistsSelfEmpEmail(null)
    //     setIsExistsSelfEmpEmailError('')
    //     setShowSearchSelfEmpEmailModal(false);

    // }

    // const addSearchSelfEmpEmailModalHeader = (
    //     <div className="custom_modal_header_inner">
    //         <h5 className="modal-title fs-5">
    //             Email validity
    //         </h5>
    //         <button type="button" className="close_modal_btn p-ripple"
    //             onClick={handleCloseSearchSelfEmpEmailModal}>
    //             <i className="bi bi-x-circle"></i>
    //             <Ripple />
    //         </button>
    //     </div>
    // );

    /*const handleSearchSelfEmpEmail = async () => {

        if(checkSearchSelfEmpEmailCredentials()){

            setLoadingSearchSelfEmpEmail(true);
            const response = await searchEmailService(searchSelfEmpEmail);
            setLoadingSearchSelfEmpEmail(false);

            if (response.status) {
                const _isExistsEmail = response.data['have_contact']
                const _isExistsEmailMsg = response.data['message']
                
            
                setIsExistsSelfEmpEmail(_isExistsEmail);
                setIsExistsSelfEmpEmailError(_isExistsEmailMsg);
            } else {
                setIsExistsSelfEmpEmail(false);
                setIsExistsSelfEmpEmailError('');
            }
        }

        

    }*/

    // function checkSearchSelfEmpEmailCredentials(): boolean {
    //         const isSearchEmailValid = checkText(searchSelfEmpEmail, true, setErrorSearchSelfEmpEmail);

    //         return isSearchEmailValid;
    // }

    // const handleUseThisSelfEmpEmail = () => {
    //     setEmail(searchSelfEmpEmail);
    //     setShowSearchSelfEmpEmailModal(false);
    //     setIsExistsSelfEmpEmailError('')
    //     setIsExistsSelfEmpEmail(null)
    //     setSearchSelfEmpEmail('')
    // }

    const onEmailConfirmSelfEmployee = (email: string) => {
        setEmail(email);
        setShowSearchSelfEmpEmailModal(false);
    }

    const onEmailConfirmCompanyEmployee = (email: string) => {
        setContactEmail(email);
        setShowSearchEmailModal(false);
    }


    /* Clear validation messages */
    // For Company employee
    // Company
    useEffect(() => {
        checkText(companyName, false, setErrorCompanyName);
    }, [companyName]);

    useEffect(() => {
        checkEmail(companyEmail, false, setErrorCompanyEmail);
    }, [companyEmail]);

    useEffect(() => {
        checkMobileNumber(companyMobile, false, setErrorCompanyMobile);
    }, [companyMobile]);

    useEffect(() => {
        checkPhoneNumber(companyLandline, false, setErrorCompanyLandline);
    }, [companyLandline]);

    useEffect(() => {
        checkText(companyAddress, false, setErrorCompanyAddress);
    }, [companyAddress]);

    useEffect(() => {
        checkText(companyCity, false, setErrorCompanyCity);
    }, [companyCity]);

    useEffect(() => {
        checkText(companyPostCode, false, setErrorCompanyPostCode);
    }, [companyPostCode]);
    // 

    // Contact
    useEffect(() => {
        checkText(contactFirstName, false, setErrorContactFirstName);
    }, [contactFirstName]);

    useEffect(() => {
        checkText(contactLastName, false, setErrorContactLastName);
    }, [contactLastName]);

    useEffect(() => {
        checkEmail(contactEmail, false, setErrorContactEmail);
    }, [contactEmail]);

    useEffect(() => {
        checkPhoneNumber(contactPrimaryPhone, false, setErrorContactPrimaryPhone);
    }, [contactPrimaryPhone]);

    useEffect(() => {
        checkPhoneNumber(contactSecondaryPhone, false, setErrorContactSecondaryPhone);
    }, [contactSecondaryPhone]);

    useEffect(() => {
        checkFileImage(contactProfileImageFile!, false, setErrorContactProfileImageFile);
    }, [contactProfileImageFile]);
    // 

    // For self employee
    // Personal
    useEffect(() => {
        checkEmail(email, false, setErrorEmail);
    }, [email]);

    useEffect(() => {
        checkText(firstName, false, setErrorFirstName);
    }, [firstName]);

    useEffect(() => {
        checkText(lastName, false, setErrorLastName);
    }, [lastName]);

    useEffect(() => {
        checkMobileNumber(mobile, false, setErrorMoblile);
    }, [mobile]);

    useEffect(() => {
        checkPhoneNumber(landline, false, setErrorLandline);
    }, [landline]);

    useEffect(() => {
        checkText(address, false, setErrorAddress);
    }, [address]);

    useEffect(() => {
        checkText(city, false, setErrorCity);
    }, [city]);

    useEffect(() => {
        checkText(postCode, false, setErrorPostCode);
    }, [postCode]);

    useEffect(() => {
        checkFileImage(personalProfileImageFile!, false, setErrorPersonalProfileImageFile);
    }, [personalProfileImageFile]);

    // Business
    useEffect(() => {
        checkEmail(businessEmail, false, setErrorBusinessEmail);
    }, [businessEmail]);

    useEffect(() => {
        checkPhoneNumber(businessMobile, false, setErrorBusinessMobile);
    }, [businessMobile]);

    useEffect(() => {
        checkPhoneNumber(businessLandline, false, setErrorBusinessLandline);
    }, [businessLandline]);

    // Role
    useEffect(() => {
        checkRole(role, false, setErrorRoleId);
    }, [role]);

    useEffect(() => {
        checkText(displayRoleName, false, setErrorDisplayRoleName);
    }, [displayRoleName]);

    useEffect(() => {
        checkText(roleName, false, setErrorRoleName);
    }, [roleName]);
    //
    /*  */

    return (
        <React.Fragment>

            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                <div className="main_head_area">
                    <h4 className="main_heading">Create Contact</h4>

                    <button className="back_btn p-ripple" onClick={goBack}>
                        <i className="bi bi-arrow-left me-2"></i>
                        Back
                        <Ripple />
                    </button>
                </div>

                <div className="page_content">
                    <div className="page_header_area">
                        <div className="contact_tabs">
                           {(isPermissionEmployee) && (<div className="contact_tab_item">
                                <button
                                    type="button"
                                    className="contact_tab_btn p-ripple"
                                    onClick={() => handleNavigateAddContact('employee')}
                                >
                                    Employee
                                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                </button>
                            </div>)} 

                           {(isPermissionProfessional) && (<div className="contact_tab_item">
                                <button
                                    type="button"
                                    className="contact_tab_btn active p-ripple"
                                    onClick={() => handleNavigateAddContact('professional')}
                                >
                                    Professional
                                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                </button>
                            </div>)}

                          {(isPermissionClient) && (<div className="contact_tab_item">
                                <button
                                    type="button"
                                    className="contact_tab_btn p-ripple"
                                    onClick={() => handleNavigateAddContact('client')}
                                >
                                    Client
                                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                </button>
                            </div>)}
                        </div>

                        <div className="select_option_area">
                            <Dropdown
                                value={employeeType}
                                id="employeeType"
                                onChange={handleEmployeeTypeChange}
                                options={employee_types}
                                optionLabel="employee_type"
                                placeholder="Employee type"
                                className="form_dropdown w-100"
                            />
                        </div>
                    </div>

                    <div className="page_label_area justify-content-center justify-content-sm-start">
                        <h6 className="text-capitalize text-center text-sm-start">{employeeType.employee_type}</h6>
                    </div>

                    {employeeType.employee_type === "Company employee" ? (
                        <div className="page_body_area mt-3" style={{ minHeight }}>
                            <div className="row">
                                <div className="col-12">
                                    <div className="add_data_track_area">
                                        <div className={`add_data_track_point has_label ${companyEmployeePage === 'Company' || companyEmployeePage === 'Contact' ? 'active' : ''}`} data-label="Company">
                                            <span>1</span>
                                        </div>

                                        <div className={`add_data_track_line ${companyEmployeePage === 'Contact' ? 'active' : ''}`}></div>

                                        <div className={`add_data_track_point has_label ${companyEmployeePage === 'Contact' ? 'active' : ''}`} data-label="Contact">
                                            <span>2</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {companyEmployeePage === 'Company' ? (
                                // Company Form
                                <div className="row mt-4">
                                    <div className="col-12 col-xxl-8 col-xl-9 mx-auto">
                                        <div className="form_right_area">
                                            <div className="page_data_form_area">
                                                <div className="row">
                                                    {/* Company name */}
                                                    <div className="col-12 col-xl-12 col-sm-12">
                                                        <div className="page_form_group text-center">
                                                            <Button
                                                                label="Find company"
                                                                onClick={() => setShowSearchCompanyDetailsModal(true)}
                                                                icon="bi bi-search"
                                                                outlined
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Company name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="companyName" className="custom_form_label is_required">Company name</label>
                                                            <InputText
                                                                id="companyName"
                                                                value={companyName}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyName(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Company name"
                                                            />

                                                            {errorCompanyName &&
                                                                <small className="form_error_msg">{errorCompanyName}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Reg No */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="companyRegNo" className="custom_form_label">Reg No</label>
                                                            <InputText
                                                                id="companyRegNo"
                                                                value={companyRegNo}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyRegNo(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Reg No"
                                                            />

                                                            {errorCompanyRegNo &&
                                                                <small className="form_error_msg">{errorCompanyRegNo}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Company Email */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="companyEmail" className="custom_form_label is_required">Company Email</label>
                                                            <InputText
                                                                id="companyEmail"
                                                                value={companyEmail}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyEmail(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Company Email"
                                                            />

                                                            {errorCompanyEmail &&
                                                                <small className="form_error_msg">{errorCompanyEmail}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Mobile */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="companyMobile" className="custom_form_label is_required">Company phone no.</label>
                                                            <InputText
                                                                id="companyMobile"
                                                                value={companyMobile}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyMobile(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Company phone no."
                                                            />

                                                            {errorCompanyMobile &&
                                                                <small className="form_error_msg">{errorCompanyMobile}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Landline */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="companyLandline" className="custom_form_label">Company landline</label>
                                                            <InputText
                                                                id="companyLandline"
                                                                value={companyLandline}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyLandline(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Company landline"
                                                            />

                                                            {errorCompanyLandline &&
                                                                <small className="form_error_msg">{errorCompanyLandline}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Company address */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="companyAddress" className="custom_form_label is_required">Company address</label>
                                                            <InputText
                                                                id="companyAddress"
                                                                value={companyAddress}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyAddress(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Company address"
                                                            />

                                                            {errorCompanyAddress &&
                                                                <small className="form_error_msg">{errorCompanyAddress}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* City */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="companyCity" className="custom_form_label is_required">City</label>
                                                            <InputText
                                                                id="companyCity"
                                                                value={companyCity}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyCity(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="City"
                                                            />

                                                            {errorCompanyCity &&
                                                                <small className="form_error_msg">{errorCompanyCity}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Post code */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="companyPostCode" className="custom_form_label is_required">Post code</label>
                                                            <InputText
                                                                id="companyPostCode"
                                                                value={companyPostCode}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyPostCode(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Post code"
                                                            />

                                                            {errorCompanyPostCode &&
                                                                <small className="form_error_msg">{errorCompanyPostCode}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Save */}
                                                    <div className="col-12">
                                                        <div className="form_btn_area justify-content-end">
                                                            <Button
                                                                label={`${loading ? 'Processing' : 'Save & Next'}`}
                                                                className="form_btn"
                                                                loading={loading}
                                                                onClick={handleSaveCompanyDetails}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : companyEmployeePage === 'Contact' ? (
                                // Contact Form
                                <div className="row mt-5">
                                    <div className="col-12 col-xxl-4 col-xl-5 mx-auto page_divider">
                                        <div className="form_left_area pt-0">
                                            <h5 className="form_left_head">
                                                {addedContactList?.length === 0 ? "Main Employee" : "Sub Employee"}
                                            </h5>
                                            <div className="form_img_upload_area pt-4">
                                                <div className="form_img_upload">
                                                    <input
                                                        type="file"
                                                        accept={imageFileExtension}
                                                        className="form_img_upload_input"
                                                        id="contactProfileImage"
                                                        onChange={handleContactImageChange}
                                                    />
                                                    <label
                                                        htmlFor="contactProfileImage"
                                                        className="form_img_upload_label"
                                                        style={{ backgroundImage: contactProfileImage ? `url(${contactProfileImage})` : `` }}
                                                    >
                                                        {!contactProfileImage && (
                                                            <div className="upload_icon">
                                                                <i className="bi bi-camera-fill"></i>
                                                            </div>
                                                        )}
                                                    </label>
                                                    {contactProfileImage ? (
                                                        <button className="upload_clear_button mt-2" onClick={clearContactImage}>Clear</button>
                                                    ) : (
                                                        <label htmlFor="contactProfileImage" className="add_image_label mt-2">Add image</label>
                                                    )}
                                                </div>
                                            </div>
                                            {errorContactProfileImageFile &&
                                                <small className="form_error_msg text-center mt-2">{errorContactProfileImageFile}</small>
                                            }

                                            {/* Added contact list */}
                                            {addedContactList?.length > 0 && (
                                                <div className="row added_contact_list_area mt-4">
                                                    {addedContactList.map((oneContact, oneContactIndex) => (
                                                        <div className="col-12 col-xl-12 col-sm-6 px-1">
                                                            <article className="added_contact_area">
                                                                <h6>
                                                                    {oneContact.first_name}
                                                                    <span>&nbsp;({oneContact.employee_type})</span>
                                                                </h6>
                                                                <p>
                                                                    <span>{oneContact.display_role_name}</span>|
                                                                    <span>{oneContact.pimary_phone_no}</span>
                                                                </p>
                                                            </article>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-12 col-xxl-8 col-xl-7 mx-auto">
                                        <div className="form_right_area">
                                            <div className="page_data_form_area">
                                                <div className="row">
                                                    {/* First name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="contactFirstName" className="custom_form_label is_required">First name</label>
                                                            <InputText
                                                                id="contactFirstName"
                                                                value={contactFirstName}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setContactFirstName(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="First name"
                                                            />

                                                            {errorContactFirstName &&
                                                                <small className="form_error_msg">{errorContactFirstName}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Last name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="contactLastName" className="custom_form_label is_required">Last name</label>
                                                            <InputText
                                                                id="contactLastName"
                                                                value={contactLastName}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setContactLastName(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Last name"
                                                            />

                                                            {errorContactLastName &&
                                                                <small className="form_error_msg">{errorContactLastName}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Email */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="contactEmail" className="custom_form_label">Email</label>

                                                            <div className="input_search_group">
                                                                <InputText
                                                                    id="contactEmail"
                                                                    value={contactEmail}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setContactEmail(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Email"
                                                                    disabled
                                                                />

                                                                {!contactEmail ? (
                                                                    <button
                                                                        className="input_grp_btn primary pos_abs p-ripple"
                                                                        onClick={() => setShowSearchEmailModal(true)}>
                                                                        <i className="bi bi-search"></i>
                                                                        <Ripple />
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        className="input_grp_btn danger pos_abs p-ripple"
                                                                        onClick={() => setContactEmail('')}>
                                                                        <i className="bi bi-x-lg"></i>
                                                                        <Ripple />
                                                                    </button>
                                                                )}
                                                            </div>

                                                            {errorContactEmail &&
                                                                <small className="form_error_msg">{errorContactEmail}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Primary Phone No */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="contactPrimaryPhone" className="custom_form_label is_required">Primary Phone No</label>
                                                            <InputText
                                                                id="contactPrimaryPhone"
                                                                value={contactPrimaryPhone}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setContactPrimaryPhone(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Primary Phone No"
                                                            />

                                                            {errorContactPrimaryPhone &&
                                                                <small className="form_error_msg">{errorContactPrimaryPhone}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Secondary phone no */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="contactSecondaryPhone" className="custom_form_label">Secondary phone no</label>
                                                            <InputText
                                                                id="contactSecondaryPhone"
                                                                value={contactSecondaryPhone}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setContactSecondaryPhone(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Secondary phone no"
                                                            />

                                                            {errorContactSecondaryPhone &&
                                                                <small className="form_error_msg">{errorContactSecondaryPhone}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Role name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <div className="w-100">
                                                                <label htmlFor="role" className="custom_form_label is_required">Role name</label>
                                                                <Dropdown value={role} id="role" onChange={(e: DropdownChangeEvent) => setRole(e.value)}
                                                                    options={roleList} optionLabel="role_name" valueTemplate={selectedRoleTemplate} itemTemplate={roleOptionTemplate}
                                                                    filter filterPlaceholder="Search here" placeholder="Select role" className="form_dropdown w-100" showClear />

                                                                {errorRoleId &&
                                                                    <small className="form_error_msg">{errorRoleId}</small>
                                                                }
                                                            </div>
                                                            <div className="add_data_area">
                                                                <button className={`add_data_btn ${showAddData ? 'danger' : ''} p-ripple`} onClick={toggleAddData}>
                                                                    <i className={`bi ${showAddData ? 'bi-dash-circle' : ' bi-plus-circle'}`}></i>
                                                                    {showAddData ? (<span>Cancel</span>)
                                                                        : (<span>Add role</span>)
                                                                    }
                                                                    < Ripple />
                                                                </button>

                                                                <div className={`add_data_input_area ${showAddData ? 'show' : ''}`}>
                                                                    <InputText
                                                                        id="roleName"
                                                                        value={roleName}
                                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setRoleName(e.target.value)}
                                                                        className="custom_form_input"
                                                                        placeholder="Enter role name"
                                                                    />

                                                                    <Button
                                                                        label="Add"
                                                                        className="ps-4 pe-4"
                                                                        onClick={handleSaveRoleName}
                                                                    />
                                                                </div>
                                                                {errorRoleName &&
                                                                    <small className="form_error_msg">{errorRoleName}</small>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Display role name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="displayRoleName" className="custom_form_label is_required">Display role name</label>
                                                            <InputText
                                                                id="displayRoleName"
                                                                value={displayRoleName}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDisplayRoleName(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Display role name"
                                                            />

                                                            {errorDisplayRoleName &&
                                                                <small className="form_error_msg">{errorDisplayRoleName}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Save */}
                                                    <div className="col-12">
                                                        <div className="form_btn_area justify-content-between flex-wrap flex-column-reverse flex-sm-row">
                                                            <button className={`add_data_btn p-ripple mt-3 mt-sm-0`}
                                                                onClick={handleAddContact}>
                                                                <i className={`bi bi-plus-circle`}></i>
                                                                Add more contact
                                                                < Ripple />
                                                            </button>

                                                            <Button
                                                                label={`${loading ? 'Processing' : 'Save'}`}
                                                                className="form_btn"
                                                                loading={loading}
                                                                onClick={handleSaveContactDetails}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    ) : employeeType.employee_type === "Self employee" ? (
                        <div className="page_body_area mt-3" style={{ minHeight }}>
                            <div className="row">
                                <div className="col-12">
                                    <div className="add_data_track_area">
                                        <div className={`add_data_track_point has_label ${selfEmployeePage === 'Personal' || selfEmployeePage === 'Business' || selfEmployeePage === 'Role' ? 'active' : ''}`} data-label="Personal">
                                            <span>1</span>
                                        </div>

                                        <div className={`add_data_track_line ${selfEmployeePage === 'Business' || selfEmployeePage === 'Role' ? 'active' : ''}`}></div>

                                        <div className={`add_data_track_point has_label ${selfEmployeePage === 'Business' || selfEmployeePage === 'Role' ? 'active' : ''}`} data-label="Business">
                                            <span>2</span>
                                        </div>

                                        <div className={`add_data_track_line ${selfEmployeePage === 'Role' ? 'active' : ''}`}></div>

                                        <div className={`add_data_track_point has_label ${selfEmployeePage === 'Role' ? 'active' : ''}`} data-label="Role">
                                            <span>3</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {selfEmployeePage === 'Personal' ? (
                                // Personal Form
                                <div className="row mt-5">
                                    <div className="col-12 col-xl-3 mx-auto page_divider">
                                        <div className="form_left_area">
                                            {/* Profile image */}
                                            <div className="form_img_upload_area">
                                                <div className="form_img_upload">
                                                    <input
                                                        type="file"
                                                        accept={imageFileExtension}
                                                        className="form_img_upload_input"
                                                        id="personalProfileImage"
                                                        onChange={handlePersonalProfileImageChange}
                                                    />
                                                    <label
                                                        htmlFor="personalProfileImage"
                                                        className="form_img_upload_label"
                                                        style={{ backgroundImage: personalProfileImage ? `url(${personalProfileImage})` : `` }}
                                                    >
                                                        {!personalProfileImage && (
                                                            <div className="upload_icon">
                                                                <i className="bi bi-camera-fill"></i>
                                                            </div>
                                                        )}
                                                    </label>
                                                    {personalProfileImage ? (
                                                        <button className="upload_clear_button mt-2" onClick={clearPersonalProfileImage}>Clear</button>
                                                    ) : (
                                                        <label htmlFor="personalProfileImage" className="add_image_label mt-2">Add image</label>
                                                    )}
                                                </div>
                                            </div>
                                            {errorPersonalProfileImageFile &&
                                                <small className="form_error_msg text-center mt-2">{errorPersonalProfileImageFile}</small>
                                            }
                                        </div>
                                    </div>

                                    <div className="col-12 col-xl-9 mx-auto">
                                        <div className="form_right_area">
                                            <div className="page_data_form_area">
                                                <div className="row">
                                                    {/* First name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="firstName" className="custom_form_label is_required">First name</label>
                                                            <InputText
                                                                id="firstName"
                                                                value={firstName}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="First name"
                                                            />

                                                            {errorFirstName &&
                                                                <small className="form_error_msg">{errorFirstName}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Last name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="lastName" className="custom_form_label is_required">Last name</label>
                                                            <InputText
                                                                id="lastName"
                                                                value={lastName}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLastName(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Last name"
                                                            />

                                                            {errorLastName &&
                                                                <small className="form_error_msg">{errorLastName}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Email */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="email" className="custom_form_label is_required">Email</label>

                                                            <div className="input_search_group">
                                                                <InputText
                                                                    id="email"
                                                                    value={email}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Email"
                                                                    disabled
                                                                />

                                                                {!email ? (
                                                                    <button
                                                                        className="input_grp_btn primary pos_abs p-ripple"
                                                                        onClick={() => setShowSearchSelfEmpEmailModal(true)}>
                                                                        <i className="bi bi-search"></i>
                                                                        <Ripple />
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        className="input_grp_btn danger pos_abs p-ripple"
                                                                        onClick={() => setEmail('')}>
                                                                        <i className="bi bi-x-lg"></i>
                                                                        <Ripple />
                                                                    </button>
                                                                )}
                                                            </div>
                                                            {errorEmail &&
                                                                <small className="form_error_msg">{errorEmail}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Mobile */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="mobile" className="custom_form_label">Mobile</label>
                                                            <InputText
                                                                id="mobile"
                                                                value={mobile}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setMobile(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Mobile"
                                                            />

                                                            {errorMoblile &&
                                                                <small className="form_error_msg">{errorMoblile}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Landline */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="landline" className="custom_form_label">Landline</label>
                                                            <InputText
                                                                id="landline"
                                                                value={landline}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLandline(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Landline"
                                                            />

                                                            {errorLandline &&
                                                                <small className="form_error_msg">{errorLandline}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Address */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="address" className="custom_form_label is_required">Address</label>
                                                            <InputText
                                                                id="address"
                                                                value={address}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAddress(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Address"
                                                            />

                                                            {errorAddress &&
                                                                <small className="form_error_msg">{errorAddress}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* City */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="city" className="custom_form_label is_required">City</label>
                                                            <InputText
                                                                id="city"
                                                                value={city}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCity(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="City"
                                                            />

                                                            {errorCity &&
                                                                <small className="form_error_msg">{errorCity}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Post code */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="postCode" className="custom_form_label is_required">Post code</label>
                                                            <InputText
                                                                id="postCode"
                                                                value={postCode}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPostCode(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Post code"
                                                            />

                                                            {errorPostCode &&
                                                                <small className="form_error_msg">{errorPostCode}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Save */}
                                                    <div className="col-12">
                                                        <div className="form_btn_area justify-content-end">
                                                            <Button
                                                                label={`${loading ? 'Processing' : 'Save & Next'}`}
                                                                className="form_btn"
                                                                loading={loading}
                                                                onClick={handleSavePersonalDetails}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : selfEmployeePage === 'Business' ? (
                                // Business Form
                                <div className="row mt-5">
                                    <div className="col-12 col-xxl-8 col-xl-9 mx-auto">
                                        <div className="form_right_area">
                                            <div className="page_data_form_area">
                                                <div className="row">
                                                    {/* Business name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="businessName" className="custom_form_label">Business name</label>
                                                            <InputText
                                                                id="businessName"
                                                                value={businessName}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBusinessName(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Business name"
                                                            />

                                                            {errorBusinessName &&
                                                                <small className="form_error_msg">{errorBusinessName}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Business email */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="businessEmail" className="custom_form_label">Business email</label>
                                                            <InputText
                                                                id="businessEmail"
                                                                value={businessEmail}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBusinessEmail(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Business email"
                                                            />

                                                            {errorBusinessEmail &&
                                                                <small className="form_error_msg">{errorBusinessEmail}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Business mobile */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="businessMobile" className="custom_form_label">Business mobile</label>
                                                            <InputText
                                                                id="businessMobile"
                                                                value={businessMobile}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBusinessMobile(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Business mobile"
                                                            />

                                                            {errorBusinessMobile &&
                                                                <small className="form_error_msg">{errorBusinessMobile}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Business landline */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="businessLandline" className="custom_form_label">Business landline</label>
                                                            <InputText
                                                                id="businessLandline"
                                                                value={businessLandline}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBusinessLandline(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Business landline"
                                                            />

                                                            {errorBusinessLandline &&
                                                                <small className="form_error_msg">{errorBusinessLandline}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Business address */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="businessAddress" className="custom_form_label">Business address</label>
                                                            <InputText
                                                                id="businessAddress"
                                                                value={businessAddress}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBusinessAddress(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Business address"
                                                            />

                                                            {errorBusinessAddress &&
                                                                <small className="form_error_msg">{errorBusinessAddress}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* City */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="businessCity" className="custom_form_label">City</label>
                                                            <InputText
                                                                id="businessCity"
                                                                value={businessCity}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBusinessCity(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="City"
                                                            />

                                                            {errorBusinessCity &&
                                                                <small className="form_error_msg">{errorBusinessCity}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Post code */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="businessPostCode" className="custom_form_label">Post code</label>
                                                            <InputText
                                                                id="businessPostCode"
                                                                value={businessPostCode}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBusinessPostCode(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Post code"
                                                            />

                                                            {errorBusinessPostCode &&
                                                                <small className="form_error_msg">{errorBusinessPostCode}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Save */}
                                                    <div className="col-12">
                                                        <div className="form_btn_area justify-content-end">
                                                            <Button
                                                                label={`${loading ? 'Processing' : 'Save & Next'}`}
                                                                className="form_btn"
                                                                loading={loading}
                                                                onClick={handleSaveBusinessDetails}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : selfEmployeePage === 'Role' ? (
                                //Role Form
                                <div className="row mt-5">
                                    <div className="col-12 col-xl-8 mx-auto h-100">
                                        <div className="page_data_form_area">
                                            <div className="form_right_area">
                                                <div className="row">
                                                    {/* Role name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <div className="w-100">
                                                                <label htmlFor="role" className="custom_form_label is_required">Role name</label>
                                                                <Dropdown value={role} id="role" onChange={(e: DropdownChangeEvent) => setRole(e.value)}
                                                                    options={roleList} optionLabel="role_name" valueTemplate={selectedRoleTemplate} itemTemplate={roleOptionTemplate}
                                                                    filter filterPlaceholder="Search here" placeholder="Select role" className="form_dropdown w-100" showClear />

                                                                {errorRoleId &&
                                                                    <small className="form_error_msg">{errorRoleId}</small>
                                                                }
                                                            </div>
                                                            <div className="add_data_area">
                                                                <button className={`add_data_btn ${showAddData ? 'danger' : ''} p-ripple`} onClick={toggleAddData}>
                                                                    <i className={`bi ${showAddData ? 'bi-dash-circle' : ' bi-plus-circle'}`}></i>
                                                                    {showAddData ? (<span>Cancel</span>)
                                                                        : (<span>Add role</span>)
                                                                    }
                                                                    < Ripple />
                                                                </button>

                                                                <div className={`add_data_input_area ${showAddData ? 'show' : ''}`}>
                                                                    <InputText
                                                                        id="roleName"
                                                                        value={roleName}
                                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setRoleName(e.target.value)}
                                                                        className="custom_form_input"
                                                                        placeholder="Enter role name"
                                                                    />

                                                                    <Button
                                                                        label="Add"
                                                                        className="ps-4 pe-4"
                                                                        onClick={handleSaveRoleName}
                                                                    />
                                                                </div>
                                                                {errorRoleName &&
                                                                    <small className="form_error_msg">{errorRoleName}</small>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Display role name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="displayRoleName" className="custom_form_label is_required">Display role name</label>
                                                            <InputText
                                                                id="displayRoleName"
                                                                value={displayRoleName}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDisplayRoleName(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Display role name"
                                                            />

                                                            {errorDisplayRoleName &&
                                                                <small className="form_error_msg">{errorDisplayRoleName}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="form_btn_area justify-content-end">
                                                            <Button
                                                                label={`${loading ? 'Processing' : 'Save'}`}
                                                                className="form_btn"
                                                                loading={loading}
                                                                onClick={handleSaveRoleDetails}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null
                            }
                        </div>
                    ) : null}
                </div>
            </div>

            {/* Show success message */}
            <div className={`message_backdrop ${showAlert ? 'show' : ''}`} onClick={handleCloseAlert}>
                <div className={`message_box ${showAlert ? 'show' : ''}`} onClick={e => e.stopPropagation()}>
                    <div className="message_box_content">
                        <i className="bi bi-check-circle-fill message_box_icon"></i>
                        <h6 className="message_box_message">
                            {successMessage}
                        </h6>
                    </div>
                </div>
            </div>
            {/*  */}

            {/* COMPANY SRARCH MODEL*/}


            <CompanySearchDialog
                visible={showSearchCompanyDetailsModal}
                onHide={() => setShowSearchCompanyDetailsModal(false)}
                onExistingCompanyDetailsConfirm={(company) => handleUseThisExistingCompanyDetails(company)}
                onCompanyDetailsConfirm={(company) => handleUseThisCompanyDetails(company)}
            />

            {/* COMPANY EMPLOYEE SRARCH MODEL*/}

            <EmailSearchDialog
                visible={showSearchEmailModal}
                contactSubtype="Company"
                onHide={() => setShowSearchEmailModal(false)}
                onEmailConfirm={(email) => onEmailConfirmCompanyEmployee(email)}
            />

            {/* SELF EMPLOYEE SRARCH MODEL*/}
            <EmailSearchDialog
                visible={showSearchSelfEmpEmailModal}
                contactSubtype="Self Employee"
                onHide={() => setShowSearchSelfEmpEmailModal(false)}
                onEmailConfirm={(email) => onEmailConfirmSelfEmployee(email)}
            />

        </React.Fragment>
    )

}

export default AddProfessionalContact;